import React, { useState, useEffect, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import NVD3Chart from "react-nvd3";
import d3 from "d3";
import Moment from "moment";
import Select from "react-select";
import { countryList } from "../../components/Conteries";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Bar, Pie } from "react-chartjs-2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Config from "../../Config.js";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import {
  countrycsvheaders,
  Citycsvheaders,
} from "./CsvHeaders/CsvHeaders";

import { Bestscancountryishowall } from '../../components/Modal/modal';
import { BestScanWiseishowall } from '../../components/Modal/modal';
import { BestScanWalletisall } from '../../components/Modal/modal';
import { BestsCityallshow } from '../../components/DataTable/datatable';
const Home = (props) => {

  let history = useHistory();
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  
  const [modalCountry, setmodalCountry] = useState(false);
  const [modalCity, setmodalCity] = useState(false);
  const [graphData, setgraphData] = useState(null);
  const [selectStartDate, setselectStartDate] = useState(Moment(new Date()).subtract("days", 30));

  const [selectEndDate, setselectEndDate] = useState(Moment(new Date()));
  const [Isloading, setIsloading] = useState(false);
  const [bestScanWiseishow, setbestScanWiseishow] = useState(false);
  const [bestscancountryishow, setbestscancountryishow] = useState(false);
  const [bestsCityallshow, setbestsCityallshow] = useState(false);
  const [Locationswisecanning, setLocationswisecanning] = useState([]);

  const [LocationsCitywisecanning, setLocationsCitywisecanning] = useState([]);
  

  const [bDownloadReady, setDownloadReady] = useState(false);
  const [countrycsvdata, setcountrycsvdata] = useState([]);

  const [cityDownloadReady, setcityDownloadReady] = useState(false);
  const [Citycsvdata, setCitycsvdata] = useState([]);
  const countrycsvRef = useRef(null);
  const CitycsvRef = useRef(null);
  

  const [DatatablecountryWiseScanLits, setDatatablecountryWiseScanLits] =
    useState([]);
  const [DatatableBestScanList, setDatatableBestScanList] = useState([]);
  const [DatatableBestScanWalletList, setDatatableBestScanWalletList] =
    useState([]);
  const [DatatableCategoryList, setDatatableCategoryList] = useState([]);

  const [DatatableLebalList, setDatatableLebalList] = useState([]);
  const [DatatableVendorWiseList, setDatatableVendorWiseList] = useState([]);
  const [subuserlist, setsubuserlist] = useState([]);

 
  const [selectuserID, setselectuserID] = useState("");
  const [selectuseronlyID, setselectuseronlyID] = useState("");


  useEffect(async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      LoadGraph(selectStartDate, selectEndDate, "");
    }
  }, []);

  const LoadGraph = async (stardate, enddate, userselect) => {
    setIsloading(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let GraphstartDate = Moment(stardate).format("YYYY/MM/DD") + " 00:00:00";
    let GraphEndDate = Moment(enddate).format("YYYY/MM/DD") + " 00:00:00";
    let subUserIDList = localStorage.getItem("subUserIDList");
  
    fetch(
      Config.apiUrl +
      "QRCodeScanHistory/DashboardAnalytics?StartDate=" +
      GraphstartDate +
      "&EndDate=" +
      GraphEndDate +
      "&PageCount=10000" +
      "&userid=" +
      userselect,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response?.status === 401) {
          history.push('/Logout');

        }
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setgraphData(responseJson);
        let responseJsonTemp = responseJson?.countryWiseScanList;
        if (responseJsonTemp) {
          responseJsonTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatablecountryWiseScanLits(
            responseJsonTemp.filter((x) => x.name !== "country13")
          );
        } else {
          setDatatablecountryWiseScanLits([]);
        }
        let bestScanWiseListTemp = responseJson?.bestScanWiseList;
        if (bestScanWiseListTemp) {
          bestScanWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableBestScanList(bestScanWiseListTemp);
        } else {
          setDatatableBestScanList([]);
        }
        let bestScancategoryWiseListTemp = responseJson?.categoryWiseList;
        if (bestScancategoryWiseListTemp) {
          bestScancategoryWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableCategoryList(bestScancategoryWiseListTemp);
          //setDatatableCategoryListtemp(bestScancategoryWiseListTemp)
        } else {
          setDatatableCategoryList([]);
          //setDatatableCategoryListtemp([]);
        }
        let bestPerformLabelWiseListTemp =
          responseJson?.bestPerformLabelWiseList.filter(
            (x) => x.labelID !== null
          );
        // let bestPerformLabelWiseListTemp = responseJson?.bestPerformLabelWiseList;
        if (bestPerformLabelWiseListTemp) {
          bestPerformLabelWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableLebalList(bestPerformLabelWiseListTemp);
        } else {
          setDatatableLebalList([]);
        }
        let bestPerformVendorWiseListTemp =
          responseJson?.bestPerformVendorWiseList;
        if (bestPerformVendorWiseListTemp) {
          bestPerformVendorWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableVendorWiseList(bestPerformVendorWiseListTemp);
        } else {
          setDatatableVendorWiseList([]);
        }

        let bestWalletTemp = responseJson?.bestScanWalletSavedWiseList;
        if (bestWalletTemp) {
          bestWalletTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableBestScanWalletList(bestWalletTemp);
        } else {
          setDatatableBestScanWalletList([]);
        }

        setIsloading(false);
        document.body.style.overflow = "auto";
      })
      .catch((error) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        console.log(error);
        setgraphData(null);
      });
  };



 
  const toggleCountry = (item) => {
    getCountrywisescanningDetail(item);
  };
  const toggleCity = (item) => {
    setbestsCityallshow(false);
    // getcitywisescanningDetail(item);
    setmodalCity(!modalCity);
  };

  const getCountrywisescanningDetail = (CountryName) => {
    let subUserIDList = localStorage.getItem("subUserIDList");
    if (
      CountryName?.name !== null &&
      CountryName?.name !== undefined &&
      CountryName?.name !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";
      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/LocationsCountrywisescansdetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.name +
        "&PageCount=10000" +
        "&userid=" +
        selectuseronlyID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            subUserCompanyID: subUserIDList,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCountry(true);

          setLocationswisecanning(responseJson);
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCountry(false);
          setIsloading(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationswisecanning([]);
        });
    } else {
      setmodalCountry(false);
      setLocationswisecanning([]);
      console.log("Country Name Not Found");
    }
  };

  const getcitywisescanningDetail = (CountryName) => {
    let subUserIDList = localStorage.getItem("subUserIDList");
    if (
      CountryName?.countryName !== null &&
      CountryName?.countryName !== undefined &&
      CountryName?.countryName !== ""
    ) {
      var cityname = "";
      if (
        CountryName?.cityName !== null &&
        CountryName?.cityName !== "null" &&
        CountryName?.cityName !== undefined &&
        CountryName?.cityName !== ""
      ) {
        cityname = CountryName?.cityName;
      }
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";
      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/LocationsCitywisescansdetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.countryName +
        "&cityName=" +
        cityname +
        "&PageCount=10000" +
        "&userid=" +
        selectuseronlyID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            subUserCompanyID: subUserIDList,
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCity(true);
          // setLocationsCitywisecanning(responseJson)
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setLocationsCitywisecanning(responseJsonTemp);
          } else {
            setLocationsCitywisecanning([]);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCity(false);
          setIsloading(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationsCitywisecanning([]);
        });
    } else {
      setmodalCity(false);
      setIsloading(false);
      setLocationsCitywisecanning([]);
      console.log("Country  Name && City Name Not Found");
    }
  };
 

  const dateRange = {
   
    currentWeek:
      Moment(selectStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("D / MM / YYYY"),
  };

  const handleDateApplyEvent = (event, picker) => {
    console.log("yyy", picker);
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");
    var currentWeek =
      startDate.format("D MMMM YYYY") + " - " + endDate.format("D MMMM YYYY");
    var prevWeek =
      Moment(startDate).subtract("days", gap).format("D MMMM") +
      " - " +
      Moment(startDate).subtract("days", 1).format("D MMMM YYYY");
    new Date(picker.startDate);

    setselectEndDate(new Date(picker.endDate));
    setselectStartDate(new Date(picker.startDate));
    LoadGraph(picker.startDate, picker.endDate, selectuseronlyID);
   
  };

  const getDate = (minusDate) => {
    var d = new Date();
    d = d.setDate(d.getDate() - minusDate);
    return d;
  };
  const areaChartData = [
    {
      key: "New visitors",
      color: "#5AC8FA",
      values: [
        { x: getDate(77), y: 13 },
        { x: getDate(76), y: 13 },
        { x: getDate(75), y: 6 },
        { x: getDate(73), y: 6 },
        { x: getDate(72), y: 6 },
        { x: getDate(71), y: 5 },
        { x: getDate(70), y: 5 },
        { x: getDate(69), y: 5 },
        { x: getDate(68), y: 6 },
        { x: getDate(67), y: 7 },
        { x: getDate(66), y: 6 },
        { x: getDate(65), y: 9 },
        { x: getDate(64), y: 9 },
        { x: getDate(63), y: 8 },
        { x: getDate(62), y: 10 },
        { x: getDate(61), y: 10 },
        { x: getDate(60), y: 10 },
        { x: getDate(59), y: 10 },
        { x: getDate(58), y: 9 },
        { x: getDate(57), y: 9 },
        { x: getDate(56), y: 10 },
        { x: getDate(55), y: 9 },
        { x: getDate(54), y: 9 },
        { x: getDate(53), y: 8 },
        { x: getDate(52), y: 8 },
        { x: getDate(51), y: 8 },
        { x: getDate(50), y: 8 },
        { x: getDate(49), y: 8 },
        { x: getDate(48), y: 7 },
        { x: getDate(47), y: 7 },
        { x: getDate(46), y: 6 },
        { x: getDate(45), y: 6 },
        { x: getDate(44), y: 6 },
        { x: getDate(43), y: 6 },
        { x: getDate(42), y: 5 },
        { x: getDate(41), y: 5 },
        { x: getDate(40), y: 4 },
        { x: getDate(39), y: 4 },
        { x: getDate(38), y: 5 },
        { x: getDate(37), y: 5 },
        { x: getDate(36), y: 5 },
        { x: getDate(35), y: 7 },
        { x: getDate(34), y: 7 },
        { x: getDate(33), y: 7 },
        { x: getDate(32), y: 10 },
        { x: getDate(31), y: 9 },
        { x: getDate(30), y: 9 },
        { x: getDate(29), y: 10 },
        { x: getDate(28), y: 11 },
        { x: getDate(27), y: 11 },
        { x: getDate(26), y: 8 },
        { x: getDate(25), y: 8 },
        { x: getDate(24), y: 7 },
        { x: getDate(23), y: 8 },
        { x: getDate(22), y: 9 },
        { x: getDate(21), y: 8 },
        { x: getDate(20), y: 9 },
        { x: getDate(19), y: 10 },
        { x: getDate(18), y: 9 },
        { x: getDate(17), y: 10 },
        { x: getDate(16), y: 16 },
        { x: getDate(15), y: 17 },
        { x: getDate(14), y: 16 },
        { x: getDate(13), y: 17 },
        { x: getDate(12), y: 16 },
        { x: getDate(11), y: 15 },
        { x: getDate(10), y: 14 },
        { x: getDate(9), y: 24 },
        { x: getDate(8), y: 18 },
        { x: getDate(7), y: 15 },
        { x: getDate(6), y: 14 },
        { x: getDate(5), y: 16 },
        { x: getDate(4), y: 16 },
        { x: getDate(3), y: 17 },
        { x: getDate(2), y: 7 },
        { x: getDate(1), y: 7 },
        { x: getDate(0), y: 7 },
      ],
    },
    {
      key: "Returning visitors",
      color: "#348fe2",
      values: [
        { x: getDate(77), y: 14 },
        { x: getDate(76), y: 13 },
        { x: getDate(75), y: 15 },
        { x: getDate(73), y: 14 },
        { x: getDate(72), y: 13 },
        { x: getDate(71), y: 15 },
        { x: getDate(70), y: 16 },
        { x: getDate(69), y: 16 },
        { x: getDate(68), y: 14 },
        { x: getDate(67), y: 14 },
        { x: getDate(66), y: 13 },
        { x: getDate(65), y: 12 },
        { x: getDate(64), y: 13 },
        { x: getDate(63), y: 13 },
        { x: getDate(62), y: 15 },
        { x: getDate(61), y: 16 },
        { x: getDate(60), y: 16 },
        { x: getDate(59), y: 17 },
        { x: getDate(58), y: 17 },
        { x: getDate(57), y: 18 },
        { x: getDate(56), y: 15 },
        { x: getDate(55), y: 15 },
        { x: getDate(54), y: 15 },
        { x: getDate(53), y: 19 },
        { x: getDate(52), y: 19 },
        { x: getDate(51), y: 18 },
        { x: getDate(50), y: 18 },
        { x: getDate(49), y: 17 },
        { x: getDate(48), y: 16 },
        { x: getDate(47), y: 18 },
        { x: getDate(46), y: 18 },
        { x: getDate(45), y: 18 },
        { x: getDate(44), y: 16 },
        { x: getDate(43), y: 14 },
        { x: getDate(42), y: 14 },
        { x: getDate(41), y: 13 },
        { x: getDate(40), y: 14 },
        { x: getDate(39), y: 13 },
        { x: getDate(38), y: 10 },
        { x: getDate(37), y: 9 },
        { x: getDate(36), y: 10 },
        { x: getDate(35), y: 11 },
        { x: getDate(34), y: 11 },
        { x: getDate(33), y: 11 },
        { x: getDate(32), y: 10 },
        { x: getDate(31), y: 9 },
        { x: getDate(30), y: 10 },
        { x: getDate(29), y: 13 },
        { x: getDate(28), y: 14 },
        { x: getDate(27), y: 14 },
        { x: getDate(26), y: 13 },
        { x: getDate(25), y: 12 },
        { x: getDate(24), y: 11 },
        { x: getDate(23), y: 13 },
        { x: getDate(22), y: 13 },
        { x: getDate(21), y: 13 },
        { x: getDate(20), y: 13 },
        { x: getDate(19), y: 14 },
        { x: getDate(18), y: 13 },
        { x: getDate(17), y: 13 },
        { x: getDate(16), y: 19 },
        { x: getDate(15), y: 21 },
        { x: getDate(14), y: 22 },
        { x: getDate(13), y: 25 },
        { x: getDate(12), y: 24 },
        { x: getDate(11), y: 24 },
        { x: getDate(10), y: 22 },
        { x: getDate(9), y: 16 },
        { x: getDate(8), y: 15 },
        { x: getDate(7), y: 12 },
        { x: getDate(6), y: 12 },
        { x: getDate(5), y: 15 },
        { x: getDate(4), y: 15 },
        { x: getDate(3), y: 15 },
        { x: getDate(2), y: 18 },
        { x: getDate(2), y: 18 },
        { x: getDate(0), y: 17 },
      ],
    },
  ];
  const areaChartOptions = {
    pointSize: 0.5,
    // useInteractiveGuideline: true,
    durection: 300,
    showControls: false,
    // showMaxMin:false,
    controlLabels: {
      stacked: "Stacked",
    },
    yAxis: {
      tickFormat: d3.format(",.0f"),
    },
    xAxis: {
      tickFormat: function (d) {
        var monthsName = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        d = new Date(parseInt(d));
        d = monthsName[d.getMonth()] + " " + d.getDate();
        return d;
      },
    },
  };

  const map = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 9,
  };
  const date = new Date();
  const formatDate = (d) => {
    console.log(d);
    var monthsName = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    d = new Date(d);
    d = monthsName[d.getMonth()] + " " + d.getDate();
    return d;
  };
  const pieChart = {
    // data: {
    //   labels: ["Android", "ISO"],
    //   datasets: [
    //     {
    //       data: [300, 160],
    //       height: [10],
    //       width: [10],
    //       backgroundColor: ["#5B8FF9", "#61DDAA"],
    //       borderColor: ["#5B8FF9", "#61DDAA"],
    //       borderWidth: 2,
    //       label: "My dataset",
    //     },
    //   ],
    // },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  };
  
  useEffect(() => {
    if (countrycsvRef && countrycsvRef.current && bDownloadReady) {
      countrycsvRef.current.link.click();
      setDownloadReady(false);
    }
  }, [bDownloadReady]);

  const handleActioncountry = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Locationswisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...Locationswisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
          };
          withheder.push(tempdata);
        }
        setcountrycsvdata(withheder);
        setDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (CitycsvRef && CitycsvRef.current && cityDownloadReady) {
      CitycsvRef.current.link.click();
      setcityDownloadReady(false);
    }
  }, [cityDownloadReady]);

  const handleActionCity = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (LocationsCitywisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...LocationsCitywisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setCitycsvdata(withheder);
        setcityDownloadReady(true);
      }
    }
  };  

  const togglecountryTableclosed = () => {
    setbestscancountryishow(false);
  };
  

  const toggleclosedBestscanned = () => {
    setbestScanWiseishow(false);
  };
 

 
  const gotoreportsAttribute = (row) => {
    console.log("row", row);
    if (
      row?.productType == "Article" ||
      row?.productType == "ArticleAttribute"
    ) {
     
      history.push({
        pathname: "/reports",
        state: { ActivePill: "1", ArticleID: row?.productID },
      });
    } else if (
      row?.productType == "Product" ||
      row?.productType == "ProductAttribute"
    ) {
      // history.push({
      //   pathname: "/dashboard/reports",
      //   state: { ActivePill: "2", ProductID: row?.productID },
      // });
      history.push({
        pathname: "/reports",
        state: { ActivePill: "2", ProductID: row?.productID },
      });
    } else if (row?.productType == "Personal") {
      // history.push({
      //   pathname: "/dashboard/reports",
      //   state: { ActivePill: "3", PersonalID: row?.productID },
      // });
      history.push({
        pathname: "/reports",
        state: { ActivePill: "3", PersonalID: row?.productID },
      });
    }
  };



  const barChart = {
    options: {
      plugins: {
        legend: {
          display: true,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          ticks: []
        },
        y: {
          ticks: {
            color: "white",
          },
        },
      },
    },
  };

  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      {/* begin breadcrumb */}
      <ol className="breadcrumb float-xl-right">
        {/* <li className="breadcrumb-item active">Home</li> */}
        <li className="breadcrumb-item active"></li>

        {/* <li className="breadcrumb-item active">Dashboard</li> */}
      </ol>
      {/* <h1 className="page-header mb-3">Dashboard</h1> */}
      <h1 className="page-header mb-3">Analytics</h1>

      <div
        // className="d-sm-flex align-items-center mb-3">
        className="row align-items-center mb-3"
      >
        <div className="col-lg-4 col-md-4 col-sm-5  my-1">
          <DateRangePicker
            startDate={selectStartDate}
            endDate={selectEndDate}
            // onApply={()=>{

            //   handleDateApplyEvent()
            // }}
            onApply={handleDateApplyEvent}
            dateFormat="DD/MM/YYYY"
          >
            <button className="btn btn-inverse text-truncate w-100">
              <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
              <span>{dateRange.currentWeek}</span>
              <b className="caret"></b>
            </button>
          </DateRangePicker>
        </div>
        {rolename === "SuperAdmin" ? (
          <div className="col-lg-4 col-md-4 col-sm-5">
            <Select
              search
              options={subuserlist}
              value={selectuserID}
              onChange={(e) => {
                // localStorage.setItem("selectuseronlyID", e.value);
                setselectuseronlyID(e.value);
                LoadGraph(selectStartDate, selectEndDate, e.value);
                setselectuserID(e);
              }}
              placeholder="Choose login user"
            />
          </div>
        ) : (
          <></>
        )}
       
        <div className="col-lg-2 col-md-3 col-sm-2 ">
          {rolename === "SuperAdmin" ? (
            <button
              type="button"
              className="btn btn-danger w-100"
              onClick={(e) => {
                setselectuserID("");
                LoadGraph(selectStartDate, selectEndDate, "");
              }}
            >
              Reset
            </button>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: "15px" }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">TOTAL SCANS</b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData?.totalScanCount}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4 col-xs-6  align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard2.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white text-truncate mb-3">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: "15px" }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">
                        Saved to stt smart wallet
                      </b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData?.totalWalletSavedCout !== null &&
                          graphData?.totalWalletSavedCout !== "" &&
                          graphData?.totalWalletSavedCout !== undefined
                          ? graphData?.totalWalletSavedCout
                          : "0"}
                      </h1>
                    </div>
                    <div className="d-flex align-items-center mb-1 mt-4">
                      <h1 className="text-white mb-0">
                        {graphData?.totalWalletSavedCoutPercent !== null &&
                          graphData?.totalWalletSavedCoutPercent !== "" &&
                          graphData?.totalWalletSavedCoutPercent !== undefined
                          ? graphData?.totalWalletSavedCoutPercent
                          : "0"}{" "}
                        %
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-4  col-xs-6 align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard1.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-8 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Time wise Analysis</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="mb-1">
                <h1 className="text-white mb-0">
                  {graphData?.totalScanCount !== null &&
                    graphData?.totalScanCount !== "" &&
                    graphData?.totalScanCount !== undefined
                    ? graphData?.totalScanCount
                    : "0"}
                </h1>
              </div>
              <div className="text-grey">
                <b className="mb-3">TOTAL SCANS</b>
              </div>
              <div style={{ height: "291px" }}>
                <div
                  className="widget-chart-full-width nvd3-inverse-mode"
                  style={{ height: "300px" }}
                >
                  {graphData !== null &&
                    graphData?.timeWiseScanList !== null ? (
                    <NVD3Chart
                      type="stackedAreaChart"
                      // datum={areaChartData}
                      datum={graphData?.timeWiseScanList}
                      height={300}
                      options={areaChartOptions}
                    />
                  ) : (
                    <div
                      style={{
                        height: "300px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="../assets/img/empty.png"
                        alt=""
                        height="170px"
                      />
                    </div>
                  )}
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-4 countrywisecss pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Country wise scans</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div>
                <div className="widget-list widget-list-rounded inverse-mode ">
                  <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                      Country
                    </h4>
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1">
                      Scans
                    </h4>
                  </div>
                  <div>
                    {DatatablecountryWiseScanLits?.slice(0, 5).map(
                      (countryWiseitem, i) => {
                        let CountryId = countryList.find(
                          (x) => x.name === countryWiseitem.name
                        );
                        return (
                          <>
                            <div className="widget-list-item ok">
                              <div className="widget-list-media icon">
                                <div
                                  className="widget-img widget-img-xs rounded bg-inverse mr-2 width-40"
                                  style={{
                                    backgroundImage: `url(https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png)`,
                                  }}
                                ></div>
                              </div>
                              <div className="widget-list-content  pb-1 pt-1 border-none">
                                <p className=" table-subtext">
                                  {countryWiseitem?.name}
                                </p>
                              </div>

                              <div className="widget-list-action text-nowrap  pb-1 pt-1">
                                <p className="table-scan-subtext">
                                  {countryWiseitem?.totalScanCount}
                                </p>
                                <button
                                  onClick={(e) => {
                                    toggleCountry(countryWiseitem);
                                  }}
                                  type="button"
                                  className="btn btn-primary btn-xs ml-3"
                                >
                                  Details
                                </button>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                  <div className="text-center p-5">
                    {DatatablecountryWiseScanLits.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          setbestscancountryishow(true);
                        }}
                      >
                        See All
                      </button>
                    )}
                    <Modal
                      isOpen={modalCountry}
                      toggle={toggleCountry}
                      className="modal-size"
                    >
                      <ModalHeader
                        toggle={toggleCountry}
                        className="modalheader "
                      >
                        <div className="d-flex align-items-center">
                          <h4 className="text-white mb-0">
                            Locations country wise scans
                          </h4>
                          {/* <button className="btn btn-primary btm-sm ml-2"onClick={(e) => ExportcountryScanDeatlis()} >
                          Download data
                        </button> */}
                          <button
                            className="btn btn-primary btm-sm ml-2"
                            onClick={(e) => handleActioncountry("DOWNLOAD")}
                          >
                            Download data
                          </button>
                          <CSVLink
                            headers={countrycsvheaders}
                            data={countrycsvdata}
                            // filename={'country ' + Moment(new Date()).utc().format('Y-MM-DD HH:mm:ss.SSS Z')+'.csv'}
                            filename={
                              "Country_" +
                              Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                              ".csv"
                            }
                            className="hidden"
                            ref={countrycsvRef}
                            target="_blank"
                          />
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <div className="sparkline8-list shadow-reset">
                          <div className="sparkline8-graph table-responsive">
                            <table
                              id="data-table-buttons"
                              className="table table-striped table-bordered table-td-valign-middle text-center"
                            >
                              <thead>
                                <tr className="odd gradeA">
                                  <th className="text-nowrap">Sr #</th>
                                  <th className="text-nowrap">Country</th>
                                  <th className="text-nowrap">City</th>
                                  <th className="text-nowrap">Scans</th>
                                  <th className="text-nowrap">Details</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Locationswisecanning.length > 0 &&
                                  Locationswisecanning.map((item, i) => (
                                    <tr>
                                      <td>{i + 1}</td>
                                      <td>{item.countryName}</td>
                                      <td>
                                        {item.cityName ? item.cityName : ""}
                                      </td>
                                      <td>{item.totalScanCount}</td>
                                      <td>
                                        <button
                                          onClick={(e) => {
                                            // toggleCity(item);
                                            getcitywisescanningDetail(item);
                                          }}
                                          type="button"
                                          className="btn btn-primary btn-xs ml-3"
                                        >
                                          Details
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="text-center">
                          {/* <button type="button" className="btn btn-purple m-5">
                          See All
                        </button> */}
                        </div>
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={modalCity}
                      toggle={toggleCity}
                      className="modal-size"
                    >
                      <ModalHeader toggle={toggleCity} className="modalheader ">
                        <div className="d-flex align-items-center">
                          <h4 className="text-white mb-0">
                            Locations city wise scans
                          </h4>
                          {/* <button className="btn btn-primary btm-sm ml-2">
                          Download data
                        </button> */}
                          <button
                            className="btn btn-primary btm-sm ml-2"
                            onClick={(e) => handleActionCity("DOWNLOAD")}
                          >
                            Download data
                          </button>
                          <CSVLink
                            headers={Citycsvheaders}
                            data={Citycsvdata}
                            // filename={'city.csv'}
                            filename={
                              "City_" +
                              Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                              ".csv"
                            }
                            className="hidden"
                            ref={CitycsvRef}
                            target="_blank"
                          />
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        {LocationsCitywisecanning.length !== null ? (
                          <div>
                            <div className="sparkline8-list shadow-reset">
                              <div className="sparkline8-graph table-responsive">
                                {bestsCityallshow === true ? (
                                  <BestsCityallshow
                                    LocationsCitywisecanningdata={LocationsCitywisecanning}
                                  ></BestsCityallshow>
                                ) : (
                                  <table
                                    id="data-table-buttons"
                                    className="table table-striped table-bordered table-td-valign-middle text-center"
                                  >
                                    <thead>
                                      <tr className="odd gradeA">
                                        <th className="text-nowrap">Sr #</th>
                                        <th className="text-nowrap">Country</th>
                                        <th className="text-nowrap">City</th>
                                        <th className="text-nowrap">
                                          QR Code Name
                                        </th>
                                        {/* <th className="text-nowrap">Type</th> */}
                                        <th className="text-nowrap">Pic</th>
                                        <th className="text-nowrap">Total Scans</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {LocationsCitywisecanning.length > 0 &&
                                        LocationsCitywisecanning.slice(
                                          0,
                                          5
                                        ).map((item, i) => (
                                          <tr>
                                            <td>{i + 1}</td>
                                            <td>{item.countryName}</td>
                                            <td>
                                              {item.cityName
                                                ? item.cityName
                                                : ""}
                                            </td>
                                            <td>
                                              {item.productName
                                                ? item.productName
                                                : ""}
                                            </td>
                                            {/* <td>{item. qrcodeType ? item. qrcodeType : "N/A"}</td> */}

                                            <td>
                                              <div>
                                                {item?.qrcodeType ===
                                                  "personalqrcode" ? (
                                                    <img style={{ height: "50px" }} src="../assets/img/noimage.jpg"></img>
                                                  // <img
                                                  //   src="../assets/img/mtsttqr.png"
                                                  //   style={{ height: "50px" }}
                                                  //   onError={({
                                                  //     currentTarget,
                                                  //   }) => {
                                                  //     currentTarget.onerror =
                                                  //       null; // prevents looping
                                                  //     currentTarget.src =
                                                  //       "../assets/img/noimage.jpg";
                                                  //   }}
                                                  // ></img>
                                                ) : (
                                                  <img
                                                    src={
                                                      Config?.contentUrl +
                                                      item?.productImagepath
                                                    }
                                                    style={{ height: "50px" }}
                                                    onError={({
                                                      currentTarget,
                                                    }) => {
                                                      currentTarget.onerror =
                                                        null; // prevents looping
                                                      currentTarget.src =
                                                        "../assets/img/mtsttqr.png";
                                                    }}
                                                  ></img>
                                                )}
                                              </div>
                                            </td>
                                            <td>{item.totalScanCount}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                            <div className="text-center">
                              {bestsCityallshow === true ? (
                                <button
                                  type="button"
                                  className="btn btn-purple m-5"
                                  onClick={(e) => {
                                    setbestsCityallshow(false);
                                  }}
                                >
                                  Hide
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-purple m-5"
                                  onClick={(e) => {
                                    setbestsCityallshow(true);
                                  }}
                                >
                                  See All
                                </button>
                              )}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                      </ModalBody>
                    </Modal>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Best scanned</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              {graphData?.bestScanWiseList?.length > 0 ? (
                <div className="table-responsive">
                  {
                    <table
                      className="table table-bordered m-b-0"
                      style={{ color: "#FFFFFF" }}
                    >
                      <thead style={{ backgroundColor: "#959595" }}>
                        <tr className="text-center">
                          <th className="table-sr-scan-width">Sr #</th>
                          <th>Name</th>
                          <th>Image</th>
                          <th className="table-scan-width">Total scans</th>
                        </tr>
                      </thead>
                      <tbody>
                        {graphData?.bestScanWiseList
                          ?.slice(0, 3)
                          .map((bestScanWiseitem, i) => {
                            return (
                              <tr className="text-center" key={i}>
                                <td className="align-middle">{i + 1}</td>
                                <td className="align-middle">
                                  {bestScanWiseitem?.productName
                                    ? bestScanWiseitem?.productName
                                    : ""}
                                </td>
                                <td>
                                  <div>
                                    <img
                                      // src="../assets/img/user/user-7.jpg"
                                      src={
                                        Config?.contentUrl +
                                        bestScanWiseitem?.imagePath
                                      }
                                      style={{ height: "50px" }}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/noimage.jpg";
                                      }}
                                    ></img>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  {bestScanWiseitem?.totalBestScanCount}
                                  {/* <button
                                    // onClick={() => {
                                    //   gotoreportsAttribute(bestScanWiseitem);
                                    // }}
                                    type="button"
                                    className="btn btn-primary btn-xs ml-3"
                                  >
                                    Details
                                  </button> */}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  }
                  <div className="text-center p-5">
                    {bestScanWiseishow === true ? (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          setbestScanWiseishow(false);
                        }}
                      >
                        Hide
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          setbestScanWiseishow(true);
                        }}
                      >
                        See All
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <h2 className="nodatatext">No Data Found</h2>
              )}
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-6 pb-4">
        <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Best scanned</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="mb-3 d-flex align-items-center"></div>

              {graphData !== null && graphData?.bestscannedBarchat !== null ? (
                <div style={{ height: "300px" }}>
                  <Bar
                    data={graphData?.bestscannedBarchat}
                    type="bar"
                    options={barChart.options}
                  />
                </div>
              ) : (
                <div
                  style={{
                    height: "300px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src="../assets/img/empty.png" alt="" height="170px" />
                </div>
              )}
            </PanelBody>
          </Panel>
         {/* <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Operating system wise scanning</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              {graphData !== null && graphData?.pipeBarchat !== null ? (
                <div style={{ height: "325px" }}>
                  <Pie
                    data={graphData?.pipeBarchat}
                    options={pieChart.options}
                  />
                </div>
              ) : (
                <h2 className="nodatatext">No Data Found</h2>
              )}
            </PanelBody>
          </Panel> */}
        </div>
      </div>
      
      <Bestscancountryishowall
        isOpen={bestscancountryishow}
        togglecountryTableclosed={() => { togglecountryTableclosed() }}
        DatatablecountryWiseScanLits={DatatablecountryWiseScanLits}
        toggleCountry={(item) => { toggleCountry(item) }}>

      </Bestscancountryishowall>
      <BestScanWiseishowall
        isOpen={bestScanWiseishow}
        toggleclosedBestscanned={() => { toggleclosedBestscanned() }}
        DatatableBestScanList={DatatableBestScanList}
        gotoreportsAttribute={(item) => { 
          //gotoreportsAttribute(item) 

        }}
      ></BestScanWiseishowall>

      {/* <BestScanWalletisall
        isOpen={bestScanWalletisall}
        toggleclosedWalletBestscanned={() => { toggleclosedWalletBestscanned() }}
        DatatableBestScanWalletList={DatatableBestScanWalletList}
        gotoreportsAttribute={(item) => {
           gotoreportsAttribute(item) 
           }}></BestScanWalletisall> */}
    </div>

  );
};

export default Home;
